<script>
    import {onMount, onDestroy} from 'svelte';
    import {sendEvent} from '../../tracking.js';
    import {asyncQuestionAnsweredEventWithAdTitle} from '../../util.js';

    export let config;
    export let pageId;
    export let changePage;
    export let writeValue;

    const allAnswers = config.answers.reduce((x, item) => x + (item.responses || 0), 0);
    let responsesVisible = false;

    function showResponses() {
        responsesVisible = true;
    }

    function getMappedResult(value) {
        return config.mapping[value] ? config.mapping[value] : false;
    }

    function loadNextPage(value) {
        showResponses();

        const mappedResult = getMappedResult(value);

        if(mappedResult) {
            const payload = {
                flParameters: `#${config.topic}##${mappedResult.fl}##${mappedResult.fl_additional}#`,
                questionId: pageId,
                questionText: config.title,
                answerId: mappedResult.fl,
                answerText: mappedResult.label || value,
            };

            sendEvent('questionAnsweredSelection', payload);
            if(mappedResult.next && mappedResult.next !== 'null') {
                asyncQuestionAnsweredEventWithAdTitle(mappedResult, payload);
                changePage(mappedResult.next);
            }
        }
    }

    function handleChange(e) {
        writeValue(`${pageId}`, e.target.value);
        loadNextPage(e.target.value);
    }

    function getAnswerBarWidth(answer) {
        let width = 0;

        if(typeof answer.responses !== 'undefined' && allAnswers > 0){
            width = (answer.responses / allAnswers) * 100;
        }

        return width;
    }

    function setup() {
        sendEvent('questionLoaded', {
            questionId: pageId,
            questionText: config.title,
        });
    }

    function destroy() {
    }

    onMount(setup);
    onDestroy(destroy);
</script>

<style src="Selection.scss"></style>

<section data-page="{pageId}" data-type="{config.type}">
    <h1>{config.title}</h1>
    <fieldset on:change={handleChange}>
        {#each config.answers as answer, i}
            <input type="radio"
                   class="answer__input"
                   name="selection"
                   id="{i}"
                   value="{answer.value}"
            />
            <label for="{i}" class={`answer__label ${(answer.icon && answer.icon !== '' && answer.icon !== 'null') ? `has--icon`: ``}`}>
                {#if answer.icon && answer.icon !== '' && answer.icon !== 'null'}
                    <span class="answer__icon">
                        {@html answer.icon}
                    </span>
                {/if}
                {answer.label}
                <div class={`answer__response ${responsesVisible ? 'is--visible' : ''}`}
                     style={`width: ${getAnswerBarWidth(answer)}%;`}>
                    <span class="answer__response__percentage">
                        {getAnswerBarWidth(answer).toFixed(2)}%
                    </span>
                </div>
            </label>
        {/each}
    </fieldset>

    <div class="result__count">
        {allAnswers} Teilnehmer
    </div>
</section>
